import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
import useReportContext from './context/useReportContext';
import Filter from './components/Filter';
import MTDSummaryTable from './components/MTDSummaryTable';
import WeeklySummaryTable from './components/WeeklySummaryTable';
import PerMDSummaryTable from './components/PerMDSummaryTable';
import {
  getMTDSummaryReport,
  getPerMDSummaryReport,
  getWeeklySummaryReport,
  postExportMTDSummaryReport,
  postExportWeeklySummaryReport,
  postExportPerMDSummaryReport,
} from '../../api/ninetyReport';

let cancelRequest;

export default function NinetyNinetyReport() {
  const auth = useStore((state) => state.auth);
  const date = new Date();

  const adminAccess = ['sub_admin', 'admin', 'KASOM', 'KASROM', 'KASH', 'RSM'];

  const defaultFilter = {
    department: { label: 'ALL', value: null },
    team: { label: 'ALL', value: null },
    manager_id: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    date_from: moment().startOf('month').format('YYYY-MM-DD'),
    date_to: moment().endOf('month').format('YYYY-MM-DD'),
    keyword: '',
  };

  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [reportData, setReportData] = useState({
    mtd_loading: true,
    weekly_loading: true,
    md_loading: true,
    mtd_data: [],
    weekly_data: [],
    md_data: [],
  });
  const [weeklyRerportColumn, setWeeklyRerportColumn] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const exportMTDSummary = async () => {
    try {
      if (cancelRequest) {
        cancelRequest.cancel('request_cancelled');
        toast.dismiss();
      }
      cancelRequest = axios.CancelToken.source();

      toast.loading('Please wait ...');
      const form = {
        department: filterForm?.department?.value,
        team: filterForm?.team?.value,
        manager_id: filterForm?.manager_id?.value,
        rep_id: filterForm?.rep_id?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      };

      const response = await postExportMTDSummaryReport(form, { cancelToken: cancelRequest.token });
      if (response === 'request_cancelled') return;
      const { code, result, message } = response.data.response;

      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();

      Swal.fire({
        title: ' ',
        text: 'File has been successfully downloaded',
        icon: 'success',
      });

      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };
  const exportWeeklySummary = async () => {
    try {
      if (cancelRequest) {
        cancelRequest.cancel('request_cancelled');
        toast.dismiss();
      }
      cancelRequest = axios.CancelToken.source();

      toast.loading('Please wait ...');
      const form = {
        department: filterForm?.department?.value,
        team: filterForm?.team?.value,
        manager_id: filterForm?.manager_id?.value,
        rep_id: filterForm?.rep_id?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      };

      const response = await postExportWeeklySummaryReport(form, {
        cancelToken: cancelRequest.token,
      });
      if (response === 'request_cancelled') return;
      const { code, result, message } = response.data.response;

      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();

      window.location.href = result;

      Swal.fire({
        title: ' ',
        text: 'File has been successfully downloaded',
        icon: 'success',
      });
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };
  const exportPerMDSummary = async () => {
    try {
      if (cancelRequest) {
        cancelRequest.cancel('request_cancelled');
        toast.dismiss();
      }
      cancelRequest = axios.CancelToken.source();

      toast.loading('Please wait ...');
      const form = {
        department: filterForm?.department?.value,
        team: filterForm?.team?.value,
        manager_id: filterForm?.manager_id?.value,
        rep_id: filterForm?.rep_id?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      };

      const response = await postExportPerMDSummaryReport(form, {
        cancelToken: cancelRequest.token,
      });
      if (response === 'request_cancelled') return;
      const { code, result, message } = response.data.response;

      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();
      Swal.fire({
        title: ' ',
        text: 'File has been successfully downloaded',
        icon: 'success',
      });
      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handlePerfCellClassName = (value) => {
    let className;
    console.log(value);
    if (parseFloat(value) >= 100) {
      className = 'cell-green';
    }

    if (parseFloat(value) >= 85 && parseFloat(value) <= 99) {
      className = 'cell-yellow';
    }

    if (parseFloat(value) >= 1 && parseFloat(value) <= 84) {
      className = 'cell-red';
    }

    if (parseFloat(value) < 1) {
      className = 'cell-super-red';
    }

    return className;
  };

  const searchReport = async () => {
    try {
      if (cancelRequest) {
        cancelRequest.cancel('request_cancelled');
      }
      cancelRequest = axios.CancelToken.source();

      setLoading(true);

      const form = {
        department: filterForm?.department?.value,
        team: filterForm?.team?.value,
        manager_id: filterForm?.manager_id?.value,
        rep_id: filterForm?.rep_id?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      };

      let dataFormat = [];
      if (activeTab === 0) {
        setReportData({ ...reportData, mtd_loading: true });
        const response = await getMTDSummaryReport(form, { cancelToken: cancelRequest.token });

        if (response === 'request_cancelled') return;

        const { code, data } = response.data;

        if (code === '200') {
          dataFormat = data?.map((row) => ({
            id: row.id,
            hierarchy: row?.hierarchy,
            md_count: row.md_count,
            target: row.target,
            completed: row.actual_call,
            vmc: row.vmc_call,
            call_perf: row.call_perf,
            completed_vmc: row.actual_vmc,
            reach: row.reach,
            concentration: row.concentration,
            bgpc: row.bgpc,
          }));
        }
        setReportData({ ...reportData, mtd_loading: false, mtd_data: dataFormat });
      }

      if (activeTab === 1) {
        setReportData({ ...reportData, md_loading: true });
        const response = await getPerMDSummaryReport(form, { cancelToken: cancelRequest.token });

        if (response === 'request_cancelled') return;

        const { code, data } = response.data;

        if (code === '200') {
          dataFormat = data?.map((row, i) => ({
            id: i,
            rep_name: row.rep_name,
            rep_designation: row.rep_designation,
            manager_name: row.manager_name,
            md_name: row.md_name,
            md_code: row.md_code,
            md_count: row.md_count,
            strat_class: row.strat_class,
            focus_md: row.focus_md,
            target: row.target,
            actual_call: row.actual_call,
            call_rate: row.call_rate,
            vmc_call: row.vmc_call,
            call_vmc_rate: row.call_vmc_rate,
            reach: row.reach,
            concentration: row.concentration,
          }));
        }

        setReportData({ ...reportData, md_loading: false, md_data: dataFormat });
      }

      if (activeTab === 2) {
        setReportData({ ...reportData, weekly_loading: true });
        const newColumns = [];

        const response = await getWeeklySummaryReport(form, { cancelToken: cancelRequest.token });
        if (response === 'request_cancelled') return;
        const { code, label, data } = response.data;

        if (code === '200') {
          label?.forEach((row, i) => {
            const rowNumber = i + 1;
            newColumns.push(
              {
                field: `plot_call_${rowNumber}`,
                headerName: row.target_header,
                headerClassName: 'super-app-theme--header row-header',
                width: 250,
              },
              {
                field: `actual_call_${rowNumber}`,
                headerName: row.actual_header,
                headerClassName: 'super-app-theme--header row-header',
                width: 250,
              },
              {
                field: `call_perf_percentage_${rowNumber}`,
                headerName: row.perf_header,
                headerClassName: 'super-app-theme--header row-header',
                cellClassName: () => handlePerfCellClassName(row.call_perf_1),
                width: 250,
              },
              {
                field: `missed_call_${rowNumber}`,
                headerClassName: 'super-app-theme--header row-header',
                headerName: row.missed_header,
                width: 250,
              },
            );
          });
          setWeeklyRerportColumn(newColumns);
          setReportData({ ...reportData, weekly_loading: false, weekly_data: data });
        }
      }

      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const clearReport = () => {
    setFilterForm(defaultFilter);
    searchReport();
  };

  useEffect(() => {
    searchReport();
  }, [activeTab]);

  return (
    <div style={{ position: 'relative' }}>
      <useReportContext.Provider
        value={useMemo(
          () => ({
            auth,
            date,
            loading,
            activeTab,
            weeklyRerportColumn,
            reportData,
            filterForm,
            adminAccess,
            setFilterForm,
            exportMTDSummary,
            exportPerMDSummary,
            exportWeeklySummary,
            searchReport,
            clearReport,
          }),
          [loading, filterForm, reportData.mtd_data, reportData.weekly_data, reportData.md_data],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab label='MTD Summary' id='mtd-summary' aria-controls='mtd-summary' />

                        <Tab
                          label='Per MD Summary'
                          id='per-md-summary'
                          aria-controls='per-md-summary'
                        />
                        <Tab
                          label='Weekly Summary'
                          id='weekly-summary'
                          aria-controls='weekly-summary'
                        />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      {activeTab === 0 ? <MTDSummaryTable /> : ''}
                      {activeTab === 1 ? <PerMDSummaryTable /> : ''}
                      {activeTab === 2 ? <WeeklySummaryTable /> : ''}
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </useReportContext.Provider>
    </div>
  );
}
